import { useSidebarStateOrHidden } from '@components/v2/layout/AppTemplate/contexts/AppTemplate.context';
import { useObjectContext } from '@components/v2/layout/ObjectScreen/hooks/useObjectContext';
import useWidth from '../../../../../components/Hooks/useWidth';
import { useRachelStore } from '../../../../rachel/store/rachel.store';
import { selectIsRachelOpen } from '../../../../rachel/store/rachel.store.selectors';
import { useCatalogView } from '../contexts/CatalogView.context';
import { getCatalogCardColumns } from '../sizing/catalogCardColumns.consts';
import { CatalogViewMode } from '../view/catalogView.types';

const useCatalogCardColumns = (): number => {
  const { activeBreakpoint } = useWidth();
  const sidebarState = useSidebarStateOrHidden();
  const isRachelOpen = useRachelStore(selectIsRachelOpen);
  const { isDetailsOpen, detailsExpansionSteps } = useObjectContext();
  const { variant, effectiveMode } = useCatalogView();

  if (effectiveMode === CatalogViewMode.LIST) {
    return 1;
  }

  const openPanelsCount =
    (sidebarState === 'expanded' ? 1 : 0) + (isRachelOpen ? 1 : 0) + (isDetailsOpen ? 1 : 0);

  const columns = getCatalogCardColumns({
    breakpoint: activeBreakpoint,
    openPanelsCount,
    variant: variant.key,
  });

  return Math.max(1, columns - detailsExpansionSteps);
};

export default useCatalogCardColumns;
